





















































































































































import Vue from "vue";
import { RootState } from "@/store";

import { getImageFromModel_48, getImageFromModel_200 } from "@/utility/Constants";
import { mapMutations, mapState, mapActions } from "vuex";
import { ADD_ALERT } from "../../store/modules/AlertModule/mutations";
import { AlertModel, AlertModelType } from "../../store/modules/AlertModule/types";
import { EditDeviceInfoRequestData, EdiDeviceInfoCommand } from "@/model/communication/device/EditDeviceInfoCommand";
import { ApiGenericResponse } from "../../model/communication/ApiGenericResponse";
import { ApiResponseStatusEnum } from "../../model/communication/ApiResponseStatusEnum";

import { GET_AVAILABLE_BRANCHES, GET_AVAILABLE_TAGS } from "@/store/modules/ApplicationModule/actions";
import { FETCH_DEVICE_TREE } from "@/store/modules/DevicesModule/actions";
import { Tag, TagValues } from "@/model/data/Tag";

// Model
import { GetInstallationsCommand } from "@/model/communication/device/GetInstallationsCommand";
import { GetInstallationsResData } from "@/model/communication/device/GetInstallationsResData";
import { GetInstallationsReqData } from "@/model/communication/device/GetInstallationsReqData";
import { Branch } from "@/model/data/Branch";

export default Vue.extend({
    data() {
        return {
            editDeviceLoading: false,
            loading: false,
            isEditDeviceEnabled: false,
            editBranchName: null,
            editTagList: [],
            showAddTagDialog: false,
            editTagName: "",
            editTagValue: "",
            installation: null,
            tagValueMaxCharactersLength: 50,
        };
    },
    props: ["installationId"],
    computed: {
        ...mapState({
            availableBranches: (state: RootState) => state.application.availableBranches,
            availableTags: (state: RootState): TagValues[] => state.application.availableTags,
        }),

        availableBranchNames() {
            if (this.availableBranches && this.availableBranches.length > 0) return this.availableBranches.map((b: Branch) => b.name);
            else return [];
        },

        availableTagNamesToAdd() {
            if (this.availableTags == null && this.availableTags.length <= 0) return [];
            else {
                let result = this.availableTags;
                // se l'installazione ha già un certo tag, allora non posso aggiungerlo!
                if (this.installation.tags && this.installation.tags.length > 0) {
                    let installationTagNames = this.installation.tags.map((t) => t.name);
                    result = this.availableTags.filter((t) => installationTagNames.filter((c) => c == t.tagName).length <= 0);
                }
                return result.map((t) => t.tagName);
            }
        },

        availableTaValuesToAdd() {
            if ((this.availableTags == null && this.availableTags.length <= 0) || this.availableTags.filter((c) => c.tagName == this.editTagName).length <= 0) return [];
            else return this.availableTags.filter((c) => c.tagName == this.editTagName)[0].availableValues;
        },
    },
    watch: {
        installationId(newValue) {
            if (newValue) this.loadInstallationInfo();
        },
    },
    methods: {
        ...mapMutations([ADD_ALERT]),
        ...mapActions([GET_AVAILABLE_BRANCHES, FETCH_DEVICE_TREE, GET_AVAILABLE_TAGS]),
        getImageFromModel_48,
        getImageFromModel_200,
        addEditTag() {
            this.editTagList.push({ name: this.editTagName, value: this.editTagValue });
            this.editTagName = "";
            this.editTagValue = "";
            this.showAddTagDialog = false;
        },
        enableEditMode() {
            this.editBranchName = this.installation.branch.name;
            this.editTagList = this.installation.tags.map((t) => ({ name: t.name, value: t.value }));

            this.isEditDeviceEnabled = true;
        },
        disableEditMode() {
            this.editBranchName = "";
            this.editTagList = [];

            this.isEditDeviceEnabled = false;
        },
        convertTag(obj: any) {
            let t = new Tag();
            t.name = obj.name;
            t.value = obj.value;
            return t;
        },
        onRemoveTag(tagName: string) {
            this.editTagList = this.editTagList.filter((c) => c.name != tagName);
        },
        async saveDeviceInfo() {
            let reqData = new EditDeviceInfoRequestData(this.installation.name);
            if (this.editBranchName) reqData.branchName = this.editBranchName;
            if (this.editTagList.length)
                this.editTagList.forEach((t) => {
                    reqData.addTag(t.name, t.value);
                });
            else reqData.tagList = [];

            let res: ApiGenericResponse = await new EdiDeviceInfoCommand(reqData).execute();
            if (res.responseStatus == ApiResponseStatusEnum.Success) {
                // se necessatio aggiorno la lista di availableBranchNames
                if (this.editBranchName != null && this.installation.branch.name != this.editBranchName) {
                    console.log("Branch changed, reload available branch names");
                    this[GET_AVAILABLE_BRANCHES]();
                }

                // se necessatio aggiorno la lista di availableTags
                let forceAvailableTagsReload = false;
                if (this.installation.tags.length != this.editTagList.length) forceAvailableTagsReload = true;
                if (forceAvailableTagsReload) {
                    console.log("Tags changed, reload available Tags");
                    this[GET_AVAILABLE_TAGS](forceAvailableTagsReload);
                }

                await this.loadInstallationInfo();
                this.disableEditMode();
            } else {
                this[ADD_ALERT](new AlertModel(AlertModelType.Error, this.$t("common.error")));
            }

            this.$emit("installation-edited");
        },
        async loadInstallationInfo() {
            try {
                if (!this.loading) {
                    this.loading = true;
                    let installationNames = [];
                    installationNames.push(this.installationId);
                    let request: GetInstallationsReqData = new GetInstallationsReqData(installationNames);
                    let res: GetInstallationsResData = await new GetInstallationsCommand(request).execute();
                    this.loading = false;
                    if (res.responseStatus == ApiResponseStatusEnum.Success) this.installation = res.installations[0];
                }
            } catch (error) {
                console.error("Error in get installations: ", error);
                this.loading = false;
            }
        },
    },
    async mounted() {
        await this.loadInstallationInfo();
        if (!this.availableBranchNames || !this.availableBranchNames.length) this[GET_AVAILABLE_BRANCHES]();
        this[GET_AVAILABLE_TAGS]();
    },
});
